import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Button, InputGroup, Form } from 'react-bootstrap';

import Wrapper from '../../components/Wrapper';
import FieldOfficersTable from '../../components/tables/FieldOfficersTable';
import PaginationComponent from '../../components/PaginationComponent';

import {
  fetchFieldOfficer,
  setSearchKeyword,
} from '../../store/features/fieldOfficerSlice';

import { getRole } from '../../utils/role';
import { useNavigate } from 'react-router-dom';
import axiosInstance from '../../utils/axios';

const FieldOfficers = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const role = getRole();

  const [searchTerm, setSearchTerm] = useState('');

  const handleToggleStatus = async (id) => {
    try {
      const response = await axiosInstance.patch(`/super-admin/field-officers/${id}/status`);

      if (response.data.success) {
        dispatch(fetchFieldOfficer({ page: currentPage, limit: 15, keyword: searchTerm, role }));
      }
    } catch (error) {
      console.error('Error toggling status:', error?.response?.data || error.message);
    }
  };

  const { fieldOfficers, status, currentPage, totalPages } = useSelector(
    (state) => state.fieldOfficers
  );

  // Client-side filtering for Partner
  const filteredData =
    (role === 'PARTNER' || role === 'TEAM_MEMBER')
      ? fieldOfficers.filter((item) =>
          Object.values(item).some(
            (val) =>
              (typeof val === 'string' || typeof val === 'number') &&
              val.toString().toLowerCase().includes(searchTerm.toLowerCase())
          )
        )
      : fieldOfficers;

  const indexOfLastItem = currentPage * 15;
  const indexOfFirstItem = indexOfLastItem - 15;
  const currentItems =
    (role === 'PARTNER' || role === 'TEAM_MEMBER')? filteredData.slice(indexOfFirstItem, indexOfLastItem) : filteredData;

  useEffect(() => {
    dispatch(fetchFieldOfficer({ page: currentPage, limit: 15, keyword: searchTerm, role }));
  }, [dispatch, currentPage, searchTerm, role]);

  return (
    <Wrapper>
      <div className="reports-container py-4 w-100">
        <div className="d-flex flex-column flex-md-row justify-content-between mb-3 w-100">
          <h1 className="fw-bolder">Field Officers</h1>
          <div className="d-flex justify-content-end align-items-center mt-3 m-md-0">
            <div className="position-relative mx-2">
              <InputGroup>
                <Form.Control
                  placeholder="Search"
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                />
                <Button
                  variant="primary"
                  onClick={() => dispatch(setSearchKeyword(searchTerm))}
                >
                  Search
                </Button>
              </InputGroup>
            </div>
            {(role === 'PARTNER' || role === 'TEAM_MEMBER') && (
              <Button
                variant="dark"
                className="ms-2"
                onClick={() => navigate('/add-field-officer')}
              >
                Add Field Officer
              </Button>
            )}
          </div>
        </div>

        {status === 'loading' ? (
          <h2>Loading...</h2>
        ) : (
          <>
            <FieldOfficersTable fieldOfficers={currentItems} role={role} onToggleStatus={handleToggleStatus} />
            <PaginationComponent
              currentPage={currentPage}
              totalPages={(role === 'PARTNER' || role === 'TEAM_MEMBER')? Math.ceil(filteredData.length / 15) : totalPages}
              fetchData={fetchFieldOfficer}
              searchKeyword={searchTerm}
              role={role}
            />
          </>
        )}
      </div>
    </Wrapper>
  );
};

export default FieldOfficers;